import api from 'helpers/api';
import { toast } from 'sonner';
import authHeader from 'helpers/auth-headers';

class TicketService {
  async createTicket(ticket) {
    try {
      const response = await api.post('/api/v2/tickets/create', ticket, { headers: { ...authHeader() } });
      return { status: 'Success', message: response.data.message };
    } catch (error) {
      if (error.response.status === 429) {
        toast.error('Too many requests', { description: 'Please wait a minute before creating another ticket' });
      } else {
        toast.error('Something went wrong', { description: 'Error creating ticket' });
      }
      return { status: 'Failed' };
    }
  }

  async getTickets() {
    try {
      const response = await api.get('/api/v2/tickets', { headers: { ...authHeader() } });
      return response.data;
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error getting tickets' });
      return [];
    }
  }

  async getDetailTicket(id) {
    try {
      const response = await api.get(`/api/v2/tickets/${id}/detail`, { headers: { ...authHeader() } });
      return response.data;
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error getting ticket detail' });
      return null;
    }
  }
}

export default new TicketService();
